const TimerClockSvg = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6.00156" cy="6.7252" r="3.775" stroke="#8277F8" />
    <path
      d="M6 4.5874V6.9624L7.1875 7.9124"
      stroke="#8277F8"
      strokeLinecap="round"
    />
    <line
      x1="1.60934"
      y1="2.90025"
      x2="3.457"
      y2="1.42212"
      stroke="#8277F8"
      strokeLinecap="round"
    />
    <line
      x1="0.5"
      y1="-0.5"
      x2="2.86616"
      y2="-0.5"
      transform="matrix(-0.780869 -0.624695 -0.624695 0.780869 10.4688 3.60303)"
      stroke="#8277F8"
      strokeLinecap="round"
    />
  </svg>
);

export default TimerClockSvg;
